import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=0b99a88c&scoped=true"
import script from "./FileUpload.vue?vue&type=script&lang=ts"
export * from "./FileUpload.vue?vue&type=script&lang=ts"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=0b99a88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b99a88c",
  null
  
)

export default component.exports